import { UploadStatusChip, type UploadStatusChipProps } from './UploadStatusChip';

// PR-CHIPS MAY 11 — groups one or more UploadStatusChips with consistent
// spacing. Used inside every list-view's new "DOCS" cell.
export function UploadStatusRow({ chips }: { chips: UploadStatusChipProps[] }) {
  return (
    <div className="inline-flex items-center gap-1">
      {chips.map((chip, i) => <UploadStatusChip key={i} {...chip} />)}
    </div>
  );
}

// PR-CHIPS MAY 11 — useFocusScroll: on detail pages, when the URL carries
// ?focus=<chipKey>, scroll #upload-<chipKey> into view and add a ring +
// brief pulse so the user immediately sees where the missing doc lives.
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useFocusScroll(): void {
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const focus = searchParams.get('focus');
    if (!focus) return;
    const el = document.getElementById(`upload-${focus}`);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    el.classList.add('ring-2', 'ring-amber-400', 'rounded-md');
    const pulseTimer = setTimeout(() => el.classList.add('animate-pulse'), 50);
    const clearTimer = setTimeout(() => {
      el.classList.remove('animate-pulse');
    }, 2500);
    return () => { clearTimeout(pulseTimer); clearTimeout(clearTimer); };
  }, [searchParams]);
}
